import {useEffect, useState} from 'react'
import {useHeaderBreadcrumb, useSubjectContext} from '../../_metronic/layout/core'
import clsx from 'clsx'
import {
  getUserList,
  homeListExperiment,
  listCircuit,
  listExperimentLog,
} from '../modules/auth/core/_requests'
import {AxiosError} from 'axios'
import {useAuth} from '../modules/auth'
import {TablesWidget12} from '../../_metronic/partials/widgets'
import {useLang} from '../../_metronic/i18n/Metronici18n'
import * as authHelper from '../../app/modules/auth/core/AuthHelpers'
import {UsersListLoading} from '../modules/apps/user-management/users-list/components/loading/UsersListLoading'
import ReportGraphCard from './Components/ReportGraphCard'
import {useIntl} from 'react-intl'

type ReportDTOItem = {
  title: string | null
  description: string | null
  type: number
  values: []
}

type DataItem = {
  id: number
  experimentId: number
  circuitId: number
  deviceId: number
  userId: number
  createdDate: string
  type: number
  deviceName: string
  circuitName: string
  experimentName: string
  userFirstName: string
  userLastName: string
  userFullName: string
  userEmail: string
  dilCode: string
}

type ExperimentLogDataType = {
  reportDTO: ReportDTOItem[]
  data: DataItem[]
}

function ExperimentLog() {
  const [experimentLogData, setExperimentLogData] = useState<ExperimentLogDataType[]>([])
  const {currentUser} = useAuth()
  const auth = authHelper.getAuth()
  const {setChangeTitle, setChangeBeforeTitle, setReturnPath} = useHeaderBreadcrumb()

  const lang = useLang()
  const intl = useIntl()

  const localSubjectId = Number(window.localStorage.getItem('subjectID'))
  const {selectedSubject} = useSubjectContext()

  const [experimentData, setExperimentData] = useState([])
  const [circuitData, setCircuitData] = useState([])
  const [userList, setUserList] = useState([])
  const [loading, setLoading] = useState<boolean>(false)
  const [experimentId, setExperimentId] = useState<number>(0)
  const [circuitId, setCircuitId] = useState<number>(0)
  const [deviceId, setDeviceId] = useState<number>(0)
  const [userId, setUserId] = useState<number>(currentUser?.id || 0)
  const [listing, setListing] = useState<boolean>(false)

  // let experimentId = 0
  //  let circuitId = 0
  //let deviceId = 0
  //let lang = 'tr'

  const getData = async () => {
    setLoading(true)
    try {
      const {data} = await listExperimentLog(0, experimentId, circuitId, deviceId, userId, lang)
      setExperimentLogData(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getExperimentList()
    getUserLists()
  }, [selectedSubject, localSubjectId])

  const getExperimentList = async () => {
    try {
      const {data} = await homeListExperiment(0, '', '', lang, '')
      setExperimentData(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  useEffect(() => {
    getCircuitList()
  }, [experimentId])

  const getCircuitList = async () => {
    try {
      const {data} = await listCircuit(0, experimentId, '', 0, 0, lang, '', [])

      setCircuitData(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  const getUserLists = async () => {
    try {
      const {data} = await getUserList('', '', 0, 0, '', true, true)
      setUserList(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  useEffect(() => {
    if (listing) {
      getData()
      setListing(false)
    }
  }, [listing])

  /*useEffect(() => {
    getData()
  }, [experimentId, userId])*/

  useEffect(() => {
    setChangeTitle('')
    setChangeBeforeTitle('')
    setReturnPath('')
  }, [])

  const getBootstrapColorByIndex = (index: number) => {
    const colors = ['primary', 'info', 'success', 'danger', 'warning', 'secondary', 'dark', 'light']

    const colorIndex = index % colors.length
    return colors[colorIndex]
  }

  const capitalizeFirstLetter = (str: string) => {
    return str
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }

  const GetReportItemData = ({data}) => {
    return (
      <>
        {data &&
          data.reportDTO &&
          data?.reportDTO.map((item: ReportDTOItem, index: number) => (
            <div key={index} className='col-lg-6 mb-4'>
              <ReportGraphCard
                className='card-xl-stretch mb-4'
                color={getBootstrapColorByIndex(index)}
                title={capitalizeFirstLetter(String(item.title))}
                data={item.values || []}
              />
            </div>
          ))}
      </>
    )
  }

  const GetDataTableItem = ({data}) => {
    const [tableData, setTableData] = useState<any>(data?.data || [])
    let itemsPerPage = 10
    const [currentPage, setCurrentPage] = useState(1)

    const indexOfLastItem = currentPage * itemsPerPage
    const indexOfFirstItem = indexOfLastItem - itemsPerPage
    const currentItems = tableData.slice(indexOfFirstItem, indexOfLastItem)
    const totalPages = Math.ceil(tableData.length / itemsPerPage)

    const columns = ['ID', 'User', 'Device Name', 'Experiment Name', 'Circuit Name', 'Created Date']
    const [sorting, setShorting] = useState({column: 'Created Date', order: 'desc'})

    const sortTable = (newSorting) => {
      setShorting(newSorting)
    }

    useEffect(() => {
      const sortArray = (type: string) => {
        const types = {
          ID: 'id',
          User: 'userFullName',
          'Device Name': 'deviceName',
          'Experiment Name': 'experimentName',
          'Circuit Name': 'circuitName',
          'Created Date': 'createdDate',
        }
        const sortProperty = types[type]

        const sorted = [...tableData].sort((a, b) => {
          if (sorting.order === 'asc') {
            return a[sortProperty] > b[sortProperty] ? 1 : -1
          } else {
            return a[sortProperty] < b[sortProperty] ? 1 : -1
          }
        })

        return sorted
      }
      setTableData(sortArray(sorting.column))
    }, [sorting])

    return (
      <div className='card'>
        <TablesWidget12
          className='mb-5 mb-xl-8'
          data={currentItems}
          excelData={experimentLogData}
          columns={columns}
          sorting={sorting}
          sortTable={sortTable}
        />
        <div className='me-5'>
          <PaginationComponent
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
          />
        </div>
      </div>
    )
  }

  return (
    <div className='row g-5 gx-xl-10 mt-lg-n16 mt-2'>
      <div className='col-xxl-12'>
        <div className='card card-flush p-5 mb-5'>
          <div className='mb-10'>
            {/* 👇 Select Experiment  👇 */}
            <label className='form-label fw-bold'>
              {intl.formatMessage({id: 'REPORTPAGE.SELECTEXPERIMENT'})}
            </label>
            {/* 👆 Select Experiment  👆 */}
            <select
              className='form-select form-select-solid'
              data-kt-select2='true'
              data-placeholder='Select option'
              data-allow-clear='true'
              value={experimentId}
              onChange={(e) => setExperimentId(Number(e.target.value))}
            >
              <option value={0}>{intl.formatMessage({id: 'REPORTPAGE.ALLEXPERIMENTS'})}</option>
              {experimentData.map((item: any, index: number) => (
                <option key={index} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
          {/*}
              <div className='mb-10'>
                <label className='form-label fw-bold'>Select Circuit</label>
                <select
                  className='form-select form-select-solid'
                  data-kt-select2='true'
                  data-placeholder='Select option'
                  data-allow-clear='true'
                  value={circuitId}
                  onChange={(e) => setCircuitId(Number(e.target.value))}
                >
                  <option value={0}>All Circuits</option>
                  {circuitData.map((item: any, index: number) => (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
                  {*/}
          <div className='mb-10'>
            {/* 👇 Select User  👇 */}
            <label className='form-label fw-bold'>
              {' '}
              {intl.formatMessage({id: 'REPORTPAGE.SELECTUSER'})}
            </label>
            {/* 👆 Select User  👆 */}
            <select
              className='form-select form-select-solid'
              data-kt-select2='true'
              data-placeholder='Select option'
              data-allow-clear='true'
              value={userId}
              onChange={(e) => setUserId(Number(e.target.value))}
            >
              <option value={0}>{intl.formatMessage({id: 'REPORTPAGE.ALLUSERS'})}</option>
              {userList.map((item: any, index: number) => (
                <option key={index} value={item.id}>
                  {item.fullName}
                </option>
              ))}
            </select>
          </div>
          {/* 👇 Listing Button  👇 */}
          <div className='d-flex justify-content-end'>
            <button type='button' className='btn btn-primary' onClick={() => setListing(true)}>
              List
            </button>
          </div>
          {/* 👆 Listing Button   👆 */}
        </div>

        {loading ? (
          <UsersListLoading />
        ) : (
          <>
            <GetReportItemData data={experimentLogData} />

            <GetDataTableItem data={experimentLogData} />
          </>
        )}
      </div>
    </div>
  )
}

export default ExperimentLog

const PaginationComponent = ({currentPage, setCurrentPage, totalPages}) => {
  const intl = useIntl()

  const handleClick = (type: any) => {
    if (type === 'prev') {
      setCurrentPage(currentPage - 1)
    } else if (type === 'next') {
      setCurrentPage(currentPage + 1)
    }
  }

  const renderPageNumbers = () => {
    const pageNumbers: any[] = []
    const pageLimit = 6 // Varsayılan sayfa sınırı
    const maxLeft = currentPage - Math.floor(pageLimit / 2)
    const maxRight = currentPage + Math.floor(pageLimit / 2)
    let ellipsisLeft = false
    let ellipsisRight = false

    for (let i = 1; i <= totalPages; i++) {
      let isActive = currentPage === i

      if (i === 1 || i === totalPages || (i >= maxLeft && i <= maxRight)) {
        pageNumbers.push(
          <li
            key={i}
            className={clsx('page-item', {
              active: isActive,
            })}
          >
            <a
              className={clsx('page-link', {})}
              style={{cursor: 'pointer'}}
              onClick={() => setCurrentPage(i)}
            >
              {i}
            </a>
          </li>
        )
      } else if (i < maxLeft && !ellipsisLeft && maxLeft > 2) {
        pageNumbers.push(
          <li key={i} className={clsx('page-item', {})}>
            <a className={clsx('page-link', {})}>...</a>
          </li>
        )
        ellipsisLeft = true
      } else if (i > maxRight && !ellipsisRight && maxRight < totalPages - 1) {
        pageNumbers.push(
          <li key={i} className={clsx('page-item', {})}>
            <a className={clsx('page-link', {})}>...</a>
          </li>
        )
        ellipsisRight = true
      }
    }

    return pageNumbers
  }

  return (
    <div className='row'>
      <div className='mb-5 pe-5 d-flex align-items-center justify-content-center justify-content-md-end'>
        <ul className='pagination'>
          <li
            className={clsx('page-item', {
              disabled: currentPage === 1,
            })}
          >
            <a
              onClick={() => handleClick('prev')}
              style={{cursor: 'pointer'}}
              className='page-link'
            >
              {intl.formatMessage({id: 'REPORTPAGE.PREV'})}
            </a>
          </li>
          {renderPageNumbers()}
          <li
            className={clsx('page-item', {
              disabled: currentPage === totalPages,
            })}
          >
            <a
              onClick={() => handleClick('next')}
              style={{cursor: 'pointer'}}
              className='page-link'
            >
              {intl.formatMessage({id: 'REPORTPAGE.NEXT'})}
            </a>
          </li>
        </ul>
      </div>
    </div>
  )
}
